import { useEffect } from "react"

export default function ScrollToHash() {
    useEffect(() => {
        const hash = window?.location.hash
        if (hash) {
            setTimeout(() => {
                const elementId = hash.slice(1)
                const element = document.getElementById(elementId)
                if (element) {
                    // Measure whichever header pins to the top of the viewport so the
                    // anchor doesn't land underneath it.
                    // - TCT2026 layout renders a fixed .siteHeader__content bar (exclusive
                    //   to that layout), but only pins on desktop — it flags itself with
                    //   data-fixed-eligible there. At the top of the page its rect.bottom
                    //   already equals where it sits once fixed, so measuring works pre-scroll.
                    //   (In mobile-menu mode the flag is absent and the bar scrolls away,
                    //   so we fall through to the .menubar path — no bar offset.)
                    // - All other layouts use the .menubar (unchanged behavior).
                    const stickyBar = document.querySelector('.siteHeader__content[data-fixed-eligible="true"]')
                    const headerBottom = stickyBar
                        ? stickyBar.getBoundingClientRect().bottom
                        : document.getElementsByClassName("menubar")[0]?.getBoundingClientRect().bottom || 0
                    const yOffset = -headerBottom - 80
                    const y = element.getBoundingClientRect().top + window.scrollY + yOffset
                    window.scrollTo({ top: y, behavior: "smooth" })
                }
            }, 700)
        }
    }, [])
    return null
}
